import { SolType, SolViewId, TypeService, ViewService } from '@sol/components';
import { AsmType } from '../models/asm-type';
import { AsmViewId } from '../models/asm-view-id';
import { AsmPriorityTools } from '../tools/asm-priority-tools';
import { AsmScoreTools } from '../tools/asm-score-tools';

export function provideAsmCoreViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmType.score);
  typeService.addType(AsmType.priority);
  typeService.addType(AsmType.country);
  typeService.addType(AsmType.featureKey);
  viewService.deriveView(SolType.severity.array, 'read', AsmType.score.array, AsmViewId.score, {
    isDefault: true,
    mapValue: (values: string[]) => values.map(v => AsmScoreTools.letterToSeverity(v)),
  });
  viewService.deriveView(SolType.tag.array, 'read', AsmType.priority.array, AsmViewId.priority, {
    isDefault: true,
    mapValue: (values: string[]) => values.map(v => AsmPriorityTools.keywordToTag(v)),
  });
  viewService.addView(
    AsmType.country,
    'read',
    AsmViewId.country,
    () =>
      import('../components/view/asm-view-read-country/asm-view-read-country.component').then(
        m => m.AsmViewReadCountryComponent,
      ),
    true,
  );
  viewService.deriveView(SolType.string.array, 'read', AsmType.featureKey, SolViewId.textField, {
    isDefault: true,
    mapValue: (key: string) => [key],
  });
  viewService.deriveView(SolType.string, 'edit', AsmType.featureKey, SolViewId.select, {
    isDefault: true,
    sourceViewId: SolViewId.select,
  });
}
